import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from '../AuthenticationInner/ParticlesAuth';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { loginUser, socialLogin, resetLoginFlag, baseSettingsColor } from '../../slices/thunks';
import logoLight from '../../assets/images/logo-light.png';
import { createSelector } from 'reselect';
import LoginButtonMicrosoft from './LoginButtonMicrosoft';
import AuthSlider from './authCarousel';
import { set } from 'lodash';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectLayoutState = state => state;
    const loginpageData = createSelector(selectLayoutState, state => ({
        user: state.Account.user,
        error: state.Login.error,
        loading: state.Login.loading,
        errorMsg: state.Login.errorMsg,
    }));

    const { user, error, loading, errorMsg } = useSelector(loginpageData);
    const [passwordShow, setPasswordShow] = useState(false);
    const [notExists, setNotExists] = useState(false);
    const [notReset, setNotReset] = useState(false);
    const [notDisabled, setNotDisabled] = useState(false);
    const [notMethod, setNotMethod] = useState(false);
    const [otherError, setOtherError] = useState(false);
    const [message, setMessage] = useState('');
    const [load, setLoad] = useState(false);

    const selectorColor = createSelector(
        (state) => state.Settings,
        (data) => ({
            itemSettingsColor: data.itemSettingsColor,
        })
    );
    const { itemSettingsColor } = useSelector(selectorColor);
    useEffect(() => {
        dispatch(baseSettingsColor())
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                // .email('Ingresa un correo electrónico válido')
                .required('Ingresa un usuario'),
            password: Yup.string().required('Ingresa una contraseña'),
        }),
        onSubmit: async (values) => {
            setLoad(true);
            setNotExists(false);
            setNotMethod(false);
            setOtherError(false);
            setMessage('');
            try {
                await dispatch(loginUser(values, navigate));
            } catch (e) {
                if (e.includes('Invalid credentials')) {
                    setNotExists(true);
                } else if (e.includes('status code 405')) {
                    setNotMethod(true);
                } else if (e.includes('status code 403')) {
                    setNotDisabled(true);
                } else if (e.includes('status code 409')) {
                    setNotReset(true);
                } else {
                    setOtherError(true);
                    setMessage(e);
                }
            } finally {
                setLoad(false);
            }
        },
    });

    // useEffect(() => {
    //     setLoad(loading);
    // }, [loading]);

    const signIn = type => {
        dispatch(socialLogin(type, navigate));
    };

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = 'SPED - Login';

    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider />
                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div>
                                                    <h5 className="text-primary">Bienvenido!</h5>
                                                    <p className="fs-13 text-muted">Inicia sesión para continuar hasta SPED.</p>
                                                </div>
                                                <div className="mt-4">
                                                    <div className='mt-4 text-center'>
                                                        <div>
                                                            <LoginButtonMicrosoft color={itemSettingsColor?.primary_color} />
                                                        </div>
                                                        <div className='signin-other-title mt-4'>
                                                            <h5 className='fs-14 mb-4 title'>Ingresar con usuario de sistema</h5>
                                                        </div>
                                                    </div>
                                                    <Form
                                                        onSubmit={e => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                        action='#'
                                                    >
                                                        <div className='mb-3'>
                                                            <Label htmlFor='email' className='fs-12 form-label'>Usuario</Label>
                                                            <Input
                                                                name='email'
                                                                className='form-control'
                                                                placeholder='Ingrese el usuario'
                                                                type='text'
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.email || ''}
                                                                invalid={validation.touched.email && validation.errors.email ? true : false}
                                                            />
                                                            {validation.touched.email && validation.errors.email ? (
                                                                <FormFeedback type='invalid'>{validation.errors.email}</FormFeedback>
                                                            ) : null}
                                                        </div>
                                                        <div className='mb-3'>
                                                            <div className='float-end'>
                                                                <Link to='/forgot-password' className='fs-12 text-muted'>Recuperar Contraseña</Link>
                                                            </div>
                                                            <Label className='fs-12 form-label' htmlFor='password-input'>Contraseña</Label>
                                                            <div className='position-relative auth-pass-inputgroup mb-3'>
                                                                <Input
                                                                    name='password'
                                                                    value={validation.values.password || ''}
                                                                    type={passwordShow ? 'text' : 'password'}
                                                                    className='form-control pe-5'
                                                                    placeholder='Ingrese la Constraseña'
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    invalid={validation.touched.password && validation.errors.password ? true : false}
                                                                />
                                                                {validation.touched.password && validation.errors.password ? (
                                                                    <FormFeedback type='invalid'>{validation.errors.password}</FormFeedback>
                                                                ) : null}
                                                                <button
                                                                    className='btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted'
                                                                    type='button'
                                                                    id='password-addon'
                                                                    onClick={() => setPasswordShow(!passwordShow)}
                                                                >
                                                                    <i className='ri-eye-fill align-middle'></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {/* <div className='form-check'>
                                                            <Input className='form-check-input' type='checkbox' value='' id='auth-remember-check' />
                                                            <Label className='fs-12 form-check-label' htmlFor='auth-remember-check'>Recordarme</Label>
                                                        </div> */}
                                                        <div className='mt-4 text-center'>
                                                            <Button
                                                                disabled={load}
                                                                color='primary'
                                                                className='btn-label w-50 color-client'
                                                                type='submit'
                                                                style={{backgroundColor: itemSettingsColor?.primary_color, borderColor: itemSettingsColor?.primary_color}}
                                                            >
                                                                {load ? (
                                                                    <i className='label-icon'><Spinner size='sm' /></i>) :
                                                                    <i className='ri-login-box-line label-icon align-middle fs-16 me-2'></i>
                                                                }
                                                                Acceder
                                                            </Button>

                                                            {notExists ? (
                                                                <div className="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
                                                                    <i className={`${Icons.alert} label-icon`}></i>El usuario o la contraseña son incorrectos
                                                                </div>
                                                            ) : null}

                                                            {notDisabled ? (
                                                                <div className="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
                                                                    <i className={`${Icons.alert} label-icon`}></i>El usuario esta deshabilitado
                                                                </div>
                                                            ) : null}

                                                            {notReset? (
                                                                <div className="alert alert-info alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
                                                                    <i className={`${Icons.alert} label-icon`}></i>El usuario esta deshabilitado momentaneamente. Revise el correo para restablecer la contraseña.
                                                                </div>
                                                            ) : null}

                                                            {notMethod ? (
                                                                <div className="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
                                                                    <i className={`${Icons.alert} label-icon`}></i>El método de acceso no es correcto. Intente ingresar mediante la autenticación del proveedor
                                                                </div>
                                                            ) : null}

                                                            {otherError ? (
                                                                <div className="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
                                                                    <i className={`${Icons.alert} label-icon`}></i>{message}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                {/* <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center ff-bas fs-12 fw-medium text-uppercase text-muted">
                                    <p className="mb-0">&copy; {new Date().getFullYear()}</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer> */}
            </div>
        </React.Fragment>
    );
};

export default React.memo(Login);
